export const rowsVar = [
  {
    id: 1,
    acc_description: 'Labor, Personnel Costs',
    priorY: '303.400 (20%)',
    rfY: '424.760 (26%)',
    priorM: '(75.850) (-5%)',
    rfM: '45.510 (3%)',
    actualRF: '(121.360) (-8%)',
    parentId: null,
    type: 'step',

  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '01 Salaries and wages',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '02 Reversal of vacations provisions',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '05 Others Personnel Costs',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '08 Sales Comissions',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '09 Travel, entertain, and missions represantations',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '12 Insurance',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '17 Office costs and consumptions',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '20 Personnel Training and Seminars',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '21 Temporary, Trainees and Subcontracting',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '34 Cost Allocation',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '46 Others Provisions',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '30.000 (20%)',
        rfY: '42.000 (26%)',
        priorM: '(7.500) (-5%)',
        rfM: '4.500 (3%)',
        actualRF: '(12.000) (-8%)',
        type: 'row',
        parentId: 1,
      },

  {
    id: 2,
    acc_description: 'Travel & Entertainment',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '09 Travel, entertain, and missions represantations',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 2,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 2,
      },

  {
    id: 3,
    acc_description: 'Rental & lease',
    priorY: '18.000 (20%)',
    rfY: '25.200 (26%)',
    priorM: '(4.500) (-5%)',
    rfM: '2.700 (3%)',
    actualRF: '(7.200) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '14 Lodging',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 3,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '15 Buildings, equipments and tools',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 3,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 3,
      },

  {
    id: 4,
    acc_description: 'Repair ¨& Maintenance, utilities',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '15 Buildings, equipments and tools',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 4,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '17 Office costs and consumptions',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 4,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 4,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 4,
      },

  {
    id: 5,
    acc_description: 'Promotion & Advertising',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '06 Promotion and advertising',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '08 Sales Comissions',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '21 Temporary, Trainees and Subcontractings',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '23 Warranty Costs',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 5,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 5,
      },

  {
    id: 6,
    acc_description: 'Depreciation & Amortization',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '25 Depreciation and amortization',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 6,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 6,
      },

  {
    id: 7,
    acc_description: 'IFRS 9 provision',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 7,
      },

  {
    id: 8,
    acc_description: 'Other provisions',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '18 Services Contracts (Security, Other 3rd Serv)',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '19 Taxes & related costs',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '23 Warranty Costs',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '25 Depreciation and amortization',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '44 Provisions for doubtful accounts',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '46 Others Provisions',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 8,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 8,
      },

  {
    id: 9,
    acc_description: 'External fees & related costs',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '11 External fees and related costs',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '19 Taxes & related costs',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '21 Temporary, Trainees and Subcontracting',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 9,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 9,
      },

  {
    id: 10,
    acc_description: 'Insurance',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '12 Insurance',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 10,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 10,
      },

  {
    id: 11,
    acc_description: 'Taxes & Related Costs',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '19 Taxes & related costs',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 11,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: 'Without Classification',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 11,
      },

  {
    id: 12,
    acc_description: 'Royalties paid',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description: 'Without Classification',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    type: 'row',
    parentId: 12,
  },

  {
    id: 13,
    acc_description: 'Other',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '03 Under/Over',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '06 Promotion and advertising',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '07 Freight on sales and related costs',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '08 Sales Comissions',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '09 Travel, entertain, and missions represantations',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '10 Telephone  / Mailling',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '11 External fees and related costs',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '14 Lodging',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '15 Buildings, equipments and tools',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '16 Water and Energy rates',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '17 Office costs and consumptions',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '18 Services Contracts (Security, Other 3rd Serv)',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '21 Temporary, Trainees and Subcontracting',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '22 Information Technology',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '23 Warranty Costs',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '24 Other expenses',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '34 Cost Allocation',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '44 Provisions for doubtful accounts',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        acc_description: '46 Others Provisions',
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },
      {
        id:  Math.random().toString(36).substr(2, 9),
        priorY: '12.000 (20%)',
        rfY: '16.800 (26%)',
        priorM: '(3.000) (-5%)',
        rfM: '1.800 (3%)',
        actualRF: '(4.800) (-8%)',
        type: 'row',
        parentId: 13,
      },

  {
    id: 14,
    acc_description: 'Allocation Costs',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    parentId: null,
    type: 'step',
  },
    {
    id:  Math.random().toString(36).substr(2, 9),
    acc_description: 'Without Classification',
    priorY: '12.000 (20%)',
    rfY: '16.800 (26%)',
    priorM: '(3.000) (-5%)',
    rfM: '1.800 (3%)',
    actualRF: '(4.800) (-8%)',
    type: 'row',
    parentId: 14,
  },

  {
    id: 99,
    acc_description: 'Total Geral',
    priorY: ' 689.600 ',
    rfY: ' 965.440 ',
    priorM: '(172.400)',
    rfM: '103.440',
    actualRF: '(275.840)',
    parentId: null,
    type: 'step',
  },
]


export const columnsVar = [
  { name: 'acc_description', title: 'ACC DESCRIPTION' , editable : false },
  { name: 'priorY', title: 'Actual x Prior Y' },
  { name: 'rfY', title: 'Actual x Prior Y' },
  { name: 'priorM', title: 'Actual x Prior M' },
  { name: 'rfM', title: 'RF x Prior M' },
  { name: 'actualRF', title: 'Actual x RF' },
];

export const headerInformationVar = {
  dateBetween: 'Jan 20 - Dec 20',
  Country: 'Brasil',
  FunctionalArea: '(P65500,P65700)',
  PersonResponsible: 'Camille Forestier',
  UserResponsible: 'SESA368320',
  CostCenter: 'BR016270'
}




